import { useConfig } from "../ConfigContext";
import { useTenant } from "../TenantContext";
import { isUsable } from "../theme/applyDocumentMeta";

/**
 * The tenant's display name for UI copy ("Search <name>", footer, alt text).
 *
 * Prefers the Site Title the tenant admin set in Branding (v1/config
 * `site_title`, e.g. "BRUSH®TV Network") — the same value used for the browser
 * tab title — over the SuperAdmin tenant name (e.g. "BrushTV"), which is an
 * internal account label. Falls back to the tenant name, then the build env.
 */
export default function useSiteTitle() {
  const config = useConfig();
  const { tenant } = useTenant();
  const candidates = [config?.site_title, tenant?.name, process.env.REACT_APP_SITE_TITLE];
  const title = candidates.find(isUsable);
  return title ? title.trim() : undefined;
}
